import { getDateTimeFormatConverter } from '../../utils/formatters';
import Message from '../message/message';

/**
 * The StaleDataMessage component displays an informational message that the data
 * being displayed on a particular view is stale.
 *
 * props:
 * - freshness: data age (seconds)
 * - timestamp: formatted timestamp of the last update (nz time)
 */
const StaleDataMessage = props => {

	let period;
	let periodUnit;

	if (props.freshness < 3600 * 48) {
		period = Math.floor(props.freshness / 3600);
		periodUnit = 'hour';
	} else {
		period = Math.floor(props.freshness / 86400);
		periodUnit = 'day';
	}

	const lastUpdate = getDateTimeFormatConverter('%Y-%m-%d %H:%M:%S', '%-I:%M %p %-d %b %Y')(props.timestamp);

	return (
		<Message level="info">
			Data has not updated since { lastUpdate } ({ period + ' ' + periodUnit + (period > 1 ? 's' : '') } ago).
		</Message>
	);

};

export default StaleDataMessage;



// WEBPACK FOOTER //
// ./components/stale-data-message/index.js